import React from "react";

import { Container, Row, Col } from "reactstrap";

import styles from './about-project.module.scss';

const AboutProjectSection = () => (
    <div id="about-project" className="section violet">
        <Container className={`${styles.aboutProject}`}>
            <Row><Col>
                <h2>O projekte</h2>
            </Col></Row>
            <Row>
                <Col className={styles.tightCol} xs="12" sm="6">
                    <h4>Cieľ</h4>
                    <p>Navrhnúť a implementovať softvérový nástroj na vizualizáciu a modelovanie
                        inteligentnej energetickej siete. Vytvorený nástroj umožní jednoduchú tvorbu 2D/3D
                        modelov energetickej siete, ktoré sa budú skladať z vopred pripravených komponentov.
                        Nástroj pomôže pri návrhu nových a optimalizácii existujúcich sietí.
                </p></Col>
                <Col className={styles.tightCol} xs="12" sm="6">
                    <h4>Charakter projektu</h4>
                    <p>Projekt má praktický charakter a jeho cieľom je vytvoriť nástroj, na vizualizáciu inteligentnej
                        elektrickej siete a jej komponentov (elektrárne, domácnosti, fotovoltaické panely,
                    veľkokapacitné batérie, nabíjacie stanice elektromobilov, atď.)</p>
                </Col>

            </Row>
        </Container>
    </div>
);

export default AboutProjectSection;